/**
 *
 * Dropdown.
 *
 */

module.exports = {

  init: function () {
    $('.mywort-dropdown').click(function(e) {
      var target = $(this).attr("drop-target");
      $("."+target).slideToggle(200);
      $(this).toggleClass('mywort-dropdown--open');
      e.stopPropagation();
    });

    $('html').click(function() {
      $('.mywort-dropdown__content, .mywort-header__sub__menu').slideUp(200);
      $(".mywort-dropdown--open").removeClass('mywort-dropdown--open');
    });

    if( $(document).find( '.date__container__left' ).length > 0 ) {
      var dateContainer = $(".date__container__left").width();
      var dateItem = $(".date__item").width();
      var nbItems = $(".date__item").length
      var itemsWidth = nbItems * dateItem;

      if(itemsWidth > dateContainer) {
        $(".date__container__displayer").show();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/mywort/styleguide/dropdown.js